import ProfilesDashboardContainer from '@/containers/profile/ProfilesDashboardContainer';
import PermissionsDashboardContainer from '@/containers/permission/PermissionsDashboardContainer';
import SegmentationDashboardContainer from '@/containers/segmentation/SegmentationDashboardContainer';

export default [
  { path: '/profiles_admin', redirect: '/profiles' },
  {
    path: '/profiles',
    name: 'ProfilesDashboard',
    meta: { requiresAuth: true, action: 'view', subject: 'profiles' },
    component: ProfilesDashboardContainer,
  },
  {
    path: '/permissions',
    name: 'permissionsDashboard',
    meta: { requiresAuth: true, action: 'view', subject: 'profiles' },
    component: PermissionsDashboardContainer,
  },
  {
    path: '/segmentation',
    name: 'SegmentationDashboard',
    meta: { requiresAuth: true, action: 'view', subject: 'profiles' },
    component: SegmentationDashboardContainer,
  },
];



// WEBPACK FOOTER //
// ./src/router/profile.js